interface Color {
  r?: number;
  g?: number;
  b?: number;
  a?: number;
  isEmpty?: boolean;
}

export const transformRBG = (color: Color) => {
  if (color.isEmpty) {
    return 'black';
  }
  const r = color.r;
  const g = color.g;
  const b = color.b;
  const a = color.a;

  return `rgba(${r},${g},${b},${a})`;
};
